import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { DashboardErrorBoundary } from "@/components/DashboardErrorBoundary";

window.addEventListener('error', (e) => {
  console.error('GLOBAL CRASH (main.tsx handler):', e.error?.stack ?? e.message);
});

createRoot(document.getElementById("root")!).render(
  <DashboardErrorBoundary>
    <App />
  </DashboardErrorBoundary>
);
